import React from 'react'
import { useI18n } from '../state/I18nContext'

const WhoWeAre: React.FC = () => {
  const { t } = useI18n()
  const content = t.whoWeAre
  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <div className="grid md:grid-cols-2 gap-10 items-start">
        <div>
          <p className="text-amber-700 font-semibold">{content.kicker}</p>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-2">
            {content.title}
          </h1>
          <p className="mt-6 text-lg text-neutral-700 leading-relaxed">
            {content.intro}
          </p>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-md">
          <img
            src="/img/decor/promo_02.png"
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>

      <div className="mt-10 text-neutral-700 leading-relaxed">
        <p>{content.essentialsIntro}</p>

        <div className="mt-6 space-y-4">
          {content.essentials.map((item, idx) => (
            <p key={idx}>
              <span className="font-semibold text-neutral-900">{item.title}:</span> {item.body}
            </p>
          ))}
        </div>

        <p className="mt-6">{content.closing}</p>
      </div>
    </section>
  )
}

export default WhoWeAre
